export const Tag01Icon = ({
  className,
  pathClassName,
}: {
  className?: string;
  pathClassName?: string;
}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
  >
    <g clipPath="url(#clip0_14858_1594)">
      <path
        d="M5.33301 5.33337H5.33968M1.33301 3.46671L1.33301 6.44972C1.33301 6.77584 1.33301 6.9389 1.36985 7.09235C1.40251 7.2284 1.45638 7.35846 1.52949 7.47775C1.61194 7.61231 1.72724 7.72761 1.95785 7.95821L7.07027 13.0706C7.8623 13.8627 8.25832 14.2587 8.71497 14.4071C9.11666 14.5376 9.54935 14.5376 9.95104 14.4071C10.4077 14.2587 10.8037 13.8627 11.5958 13.0706L13.0703 11.5961C13.8623 10.8041 14.2583 10.4081 14.4067 9.95141C14.5372 9.54972 14.5372 9.11703 14.4067 8.71534C14.2583 8.25868 13.8623 7.86267 13.0703 7.07063L7.95785 1.95821C7.72724 1.72761 7.61194 1.61231 7.47739 1.52985C7.35809 1.45675 7.22803 1.40288 7.09198 1.37021C6.93853 1.33337 6.77547 1.33337 6.44935 1.33337L3.46634 1.33337C2.7196 1.33337 2.34624 1.33337 2.06102 1.4787C1.81014 1.60653 1.60616 1.8105 1.47833 2.06139C1.33301 2.3466 1.33301 2.71997 1.33301 3.46671ZM5.66634 5.33337C5.66634 5.51747 5.5171 5.66671 5.33301 5.66671C5.14891 5.66671 4.99968 5.51747 4.99968 5.33337C4.99968 5.14928 5.14891 5.00004 5.33301 5.00004C5.5171 5.00004 5.66634 5.14928 5.66634 5.33337Z"
        stroke="#0C111D"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={pathClassName}
      />
    </g>
    <defs>
      <clipPath id="clip0_14858_1594">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
